/* SP-LOGO-PLACE (14.10.2026, Board 236 A) – Regler, Eckgriff, Schnellwahl, Platzierungssatz. Doku + Texte (DE/EN): sections/sp-logo-preview.liquid */
(function () {
  'use strict';
  var EN = /^en/i.test(document.documentElement.lang || ''), T = {}, LBL = {};
  function tp(s, x) { return String(s || '').replace('{x}', x); }
  function num(v) { var n = parseFloat(String(v == null ? '' : v).replace(',', '.')); return isFinite(n) ? n : NaN; }
  function r05(v) { return Math.round(v * 2) / 2; }
  function fmt(v) { return String(r05(v)).replace('.', ','); } // Inhaber 17.10.2026: deutsches Zahlenformat (Komma) auch unter /en/
  function mk(tag, cls, txt) { var d = document.createElement(tag); if (cls) d.className = cls; if (txt != null) d.textContent = txt; return d; }

  function init(el) {
    var st = el.spnState;
    if (el.dataset.splpPlace || !st || !el.dataset.splpReady) return !!el.dataset.splpPlace;
    var stage = el.querySelector('.spn-stage'), layer = stage && stage.querySelector('.splp-layer');
    var box = layer && layer.querySelector('.splp-logos'), gArea = layer && layer.querySelector('.splp-guides rect');
    var cards = el.querySelector('[data-spn-logos]');
    if (!box || !gArea || !cards) return false;
    try { T = JSON.parse(document.querySelector('[data-splpl-txt]').textContent); EN = !!T.en; LBL = T.lbl || {}; } catch (e) { return false; }
    el.dataset.splpPlace = '1';
    var cfg = {};
    try { cfg = JSON.parse(document.querySelector('[data-splp-data]').textContent) || {}; } catch (e) {}
    var CP = cfg.positions || {}, cache = {}, moved = false, raf = 0;

    function defOf(k) {
      var d = (el.spnPosDefs && el.spnPosDefs[k]) || null, a = null;
      (el.spnAris || []).forEach(function (m) { m.pos.forEach(function (q) { if (q.key === k && q.area) a = q.area; }); });
      return {
        area: (CP[k] && CP[k].area) || a || (d && d.area) || (/kragen/.test(k) ? [7, 2] : [10, 10]),
        w: (CP[k] && CP[k].w) || (d && d.w) || 8
      };
    }
    function vert(k) { return /ruecken|schulter|brust-komplett/.test(k); } // SP-BRUSTMITTE: Brust komplett wie Rücken komplett (Oben/Mittig/Unten)
    function widthOf(lg) { var w = num(lg.width); return w > 0 ? w : defOf(lg.pos).w; }
    function lim(lg) {
      var A = defOf(lg.pos).area[0], base = lg.fin === 'stick' ? 3 : 4;
      var mn = A <= 10 ? Math.min(base, Math.floor(A * 0.3 * 2) / 2) : base;
      return [Math.max(1, mn), A];
    }
    function logoEl(i) { return box.querySelector('.splp-logo[data-i="' + i + '"]'); }
    function rotated(d) { return /rotate/.test(d.style.transform || ''); }
    // SP-CAP (17.10.2026): leicht gedrehte Logos (Cap-Seitenteile ±8°) behalten den Eckgriff; Ärmel/Kragen (≥ 20°) nicht
    function rotDeg(d) { var m = /rotate\(\s*(-?[\d.]+)deg/.exec(d.style.transform || ''); return m ? parseFloat(m[1]) : 0; }
    function sig(lg) { var o = lg._splp || {}; return [lg.pos, lg.width, o.dx, o.dy, lg.file ? lg.file.name : '', st.later].join('|'); }
    function label(lg) {
      var l = lg.posLabel || lg.pos;
      if (!EN) return l;
      var t = window.spI18nEn && window.spI18nEn.tr ? window.spI18nEn.tr(l) : l;
      return t !== l ? t : (LBL[l] || l);
    }

    /* Lage messen: gerenderte Logo- und Flächenposition (px) → cm über die Flächenbreite */
    function measure(i) {
      var lg = st.logos[i], d = logoEl(i);
      if (!lg || !d || d.hidden || layer.hidden || !d.classList.contains('is-active')) return null;
      var A = defOf(lg.pos).area, o = lg._splp || { dx: 0, dy: 0 };
      var img = !!d.querySelector('img') && !d.classList.contains('is-ph');
      var wp = parseFloat(d.style.width), hp = parseFloat(d.style.height), w = widthOf(lg), h = w * (hp / wp || 1);
      var m = { w: w, h: h, img: img, rot: rotated(d) };
      var aw = +gArea.getAttribute('width');
      if (m.rot || !(aw > 0) || gArea.closest('svg').style.display === 'none') {
        m.l = (A[0] - w) / 2 + (o.dx || 0); m.r = A[0] - w - m.l;
        m.t = (A[1] - h) / 2 + (o.dy || 0); m.b = A[1] - h - m.t;
      } else {
        var k = aw / A[0], ax = +gArea.getAttribute('x'), ay = +gArea.getAttribute('y'), ah = +gArea.getAttribute('height');
        var x = parseFloat(d.style.left), y = parseFloat(d.style.top);
        m.l = (x - ax) / k; m.r = (ax + aw - x - wp) / k; m.t = (y - ay) / k; m.b = (ay + ah - y - hp) / k;
      }
      cache[i] = { s: sig(lg), m: m };
      return m;
    }
    function got(i) { var lg = st.logos[i]; return measure(i) || (cache[i] && lg && cache[i].s === sig(lg) ? cache[i].m : null); }

    function sentence(i) {
      var lg = st.logos[i];
      if (!lg) return '';
      var m = el.classList.contains('spn-noprev') || st.later ? null : got(i), L = label(lg);
      if (!m || !m.img) return L + ': ' + tp(T.only, fmt(widthOf(lg)));
      var p = [fmt(m.w) + ' × ' + fmt(m.h) + ' cm'];
      p.push(m.t < 0.3 ? T.top0 : fmt(m.t) + T.top);
      var sd = lg.pos === 'links' ? 1 : lg.pos === 'rechts' ? -1 : 0;
      if (Math.abs(m.l - m.r) < 0.5) p.push(T.mid);
      else if (sd) {
        // Brust links/rechts: Lage zur Körpermitte bzw. zum Arm (eindeutig für Kunde und Produktion, 14.10.2026)
        var inn = sd > 0 ? m.l : m.r, out = sd > 0 ? m.r : m.l;
        var Ti = EN ? [' cm from inner edge (centre front)', 'flush inner (centre front)', ' cm from outer edge (sleeve)', 'flush outer (sleeve)']
          : [' cm vom inneren Rand (Körpermitte)', 'bündig innen (Körpermitte)', ' cm vom äußeren Rand (Arm)', 'bündig außen (Arm)'];
        if (inn <= out) p.push(inn < 0.3 ? Ti[1] : fmt(inn) + Ti[0]);
        else p.push(out < 0.3 ? Ti[3] : fmt(out) + Ti[2]);
      }
      else if (m.l <= m.r) p.push(m.l < 0.3 ? T.bl : fmt(m.l) + T.fl);
      else p.push(m.r < 0.3 ? T.br : fmt(m.r) + T.fr);
      return L + ': ' + p.join(' · ');
    }

    /* Verschieben über die Vorschau: Zustand setzen, Pfeiltaste nach links lässt neu zeichnen und begrenzt */
    function apply(i, dx, dy) {
      var lg = st.logos[i], o = lg && lg._splp;
      if (!o) return;
      var d = logoEl(i);
      o.dy = dy;
      if (d) { o.dx = dx + 0.5; d.dispatchEvent(new KeyboardEvent('keydown', { key: 'ArrowLeft', bubbles: true, cancelable: true })); }
      else { o.dx = dx; el.dispatchEvent(new CustomEvent('spn:change', { detail: st })); }
    }
    function setWidth(i, v) {
      var c = cards.querySelectorAll('.spn-logo')[i], wi = c && c.querySelector('.spn-wbox input');
      if (!wi) return;
      wi.value = fmt(v);
      wi.dispatchEvent(new Event('input', { bubbles: true }));
      wi.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function preset(i, n) {
      var lg = st.logos[i], o = lg && lg._splp;
      if (!o) return;
      moved = true;
      if (!vert(lg.pos)) { apply(i, [-999, 0, 999][n], o.dy || 0); return; }
      var dy = n === 0 ? -999 : n === 2 ? 999 : 0;
      if (n === 1) { var m = measure(i); dy = m ? r05((o.dy || 0) + (m.b - m.t) / 2) : 0; }
      apply(i, 0, dy);
    }
    function which(i) {
      var lg = st.logos[i], m = lg && got(i);
      if (!m) return -1;
      var a = vert(lg.pos) ? m.t : m.l, b = vert(lg.pos) ? m.b : m.r;
      if (Math.abs(a - b) < 0.5) return 1;
      return a < 0.3 ? 0 : (b < 0.3 ? 2 : -1);
    }

    /* ---------- Schritt 3: Regler, Schnellwahl, Satz ---------- */
    function inject() {
      Array.prototype.forEach.call(cards.querySelectorAll('.spn-logo'), function (c, i) {
        if (c.querySelector('.splpl')) return;
        var row = c.querySelector('.spn-lrow--split');
        if (!row) return;
        var u = mk('div', 'splpl');
        u.innerHTML = '<div class="splpl__row"><span class="splpl__lbl"></span><strong class="splpl__wv"></strong></div>' +
          '<input type="range" class="splpl__rng" step="0.5"><div class="splpl__row"><span class="splpl__mm"></span><span class="splpl__mm"></span></div>' +
          '<div class="splpl__pos"><div class="splpl__row"><span class="splpl__lbl"></span><button type="button" class="splpl__reset"></button></div>' +
          '<div class="splpl__pills"><button type="button"></button><button type="button"></button><button type="button"></button></div></div>' +
          '<p class="splpl__read"></p><p class="splpl__info"></p>';
        var lb = u.querySelectorAll('.splpl__lbl');
        lb[0].textContent = T.w; lb[1].textContent = T.lage;
        u.querySelector('.splpl__reset').textContent = T.reset;
        u.querySelector('.splpl__info').textContent = T.info;
        var rng = u.querySelector('.splpl__rng');
        rng.setAttribute('aria-label', tp(T.rng, i + 1));
        rng.addEventListener('input', function () { moved = true; setWidth(i, num(rng.value)); });
        Array.prototype.forEach.call(u.querySelectorAll('.splpl__pills button'), function (b, n) {
          b.addEventListener('click', function () { preset(i, n); });
        });
        u.querySelector('.splpl__reset').addEventListener('click', function () { var o = st.logos[i] && st.logos[i]._splp; apply(i, 0, 0); if (o) moved = true; });
        row.parentNode.insertBefore(u, row.nextSibling);
      });
      sched();
    }
    function cardsUi() {
      var noprev = el.classList.contains('spn-noprev');
      Array.prototype.forEach.call(cards.querySelectorAll('.spn-logo'), function (c, i) {
        var u = c.querySelector('.splpl'), lg = st.logos[i];
        if (!u || !lg) return;
        var L = lim(lg), w = widthOf(lg), rng = u.querySelector('.splpl__rng'), mm = u.querySelectorAll('.splpl__mm');
        rng.min = L[0]; rng.max = L[1];
        var rv = String(Math.max(L[0], Math.min(L[1], r05(w))));
        if (rng.value !== rv) rng.value = rv;
        u.querySelector('.splpl__wv').textContent = fmt(w) + ' cm';
        mm[0].textContent = fmt(L[0]) + ' cm'; mm[1].textContent = fmt(L[1]) + ' cm · ' + T.full;
        var pos = u.querySelector('.splpl__pos'), names = vert(lg.pos) ? T.v : T.h, cur = which(i);
        var np = !!(lg._splp && lg._splp.nophoto); // SP-CAP: Logo ohne Bildvorschau (Cap „Hinten“ ohne Rückfoto)
        pos.hidden = noprev || st.later || np;
        var inf = u.querySelector('.splpl__info');
        if (inf.hidden !== np) inf.hidden = np;
        Array.prototype.forEach.call(u.querySelectorAll('.splpl__pills button'), function (b, n) {
          if (b.textContent !== names[n]) b.textContent = names[n];
          b.setAttribute('aria-pressed', cur === n ? 'true' : 'false');
        });
        var o = lg._splp || {};
        u.querySelector('.splpl__reset').hidden = !(o.dx || o.dy);
        var s = sentence(i), rd = u.querySelector('.splpl__read');
        if (rd.textContent !== s) rd.textContent = s;
      });
    }

    /* ---------- Foto: Eckgriff, Mittellinie, Hinweis-Chip ---------- */
    var hdl = mk('span', 'splpl-h'), mid = mk('span', 'splpl-mid'), chip = mk('span', 'splpl-chip', T.chip);
    hdl.setAttribute('aria-hidden', 'true'); mid.setAttribute('aria-hidden', 'true');
    hdl.hidden = mid.hidden = chip.hidden = true;
    stage.appendChild(mid); stage.appendChild(hdl); stage.appendChild(chip);
    function stageUi() {
      var off = layer.hidden || stage.classList.contains('splp-zoom') || el.classList.contains('spn-noprev');
      var act = off ? null : box.querySelector('.splp-logo.is-active:not([hidden])');
      if (act) measure(+act.dataset.i);
      var rd = act ? rotDeg(act) : 0;
      var ok = act && (!rotated(act) || (rd && Math.abs(rd) <= 12));
      hdl.hidden = !ok;
      if (ok) {
        var aw = parseFloat(act.style.width), ah = parseFloat(act.style.height);
        var ax = parseFloat(act.style.left) + aw / 2, ay = parseFloat(act.style.top) + ah / 2, rr = rd * Math.PI / 180;
        // Ecke unten rechts (bei gedrehten Logos die gedrehte Ecke)
        hdl.style.left = (ax + aw / 2 * Math.cos(rr) - ah / 2 * Math.sin(rr)) + 'px';
        hdl.style.top = (ay + aw / 2 * Math.sin(rr) + ah / 2 * Math.cos(rr)) + 'px';
      }
      var dr = ok && !rotated(act) && act.classList.contains('is-drag') && gArea.closest('svg').style.display !== 'none';
      mid.hidden = !dr;
      if (dr) {
        mid.style.left = (+gArea.getAttribute('x') + +gArea.getAttribute('width') / 2) + 'px';
        mid.style.top = gArea.getAttribute('y') + 'px';
        mid.style.height = gArea.getAttribute('height') + 'px';
      }
      chip.hidden = moved || off || !box.querySelector('.splp-logo:not([hidden])');
    }
    function refresh() { raf = 0; try { stageUi(); cardsUi(); } catch (e) { console.warn('[sp-logo-place]', e); } }
    function sched() { if (!raf) raf = setTimeout(refresh, 0); }
    function seen() { var a = box.querySelector('.splp-logo.is-active:not([hidden])'); if (a) measure(+a.dataset.i); sched(); } // Lage nach jedem Zeichnen merken

    var hd = null;
    hdl.addEventListener('pointerdown', function (e) {
      var act = box.querySelector('.splp-logo.is-active:not([hidden])'), i = act ? +act.dataset.i : -1, lg = st.logos[i];
      if (!lg || (e.button != null && e.button !== 0)) return;
      e.preventDefault(); e.stopPropagation();
      moved = true;
      hd = { i: i, x: e.clientX, y: e.clientY, w0: widthOf(lg), wp: act.offsetWidth || 1, hp: act.offsetHeight || 1, dx0: (lg._splp && lg._splp.dx) || 0, last: widthOf(lg) };
      try { hdl.setPointerCapture(e.pointerId); } catch (err) {}
    });
    hdl.addEventListener('pointermove', function (e) {
      if (!hd) return;
      var lg = st.logos[hd.i], L = lim(lg);
      var d = ((e.clientX - hd.x) + (e.clientY - hd.y) * hd.wp / hd.hp) / 2;
      var v = Math.max(L[0], Math.min(L[1], r05(hd.w0 * (hd.wp + d) / hd.wp)));
      if (v === hd.last) return;
      hd.last = v;
      if (lg._splp) lg._splp.dx = r05(hd.dx0 + (v - hd.w0) / 2); // linke Kante bleibt stehen
      setWidth(hd.i, v);
    });
    function hEnd() { hd = null; sched(); }
    hdl.addEventListener('pointerup', hEnd);
    hdl.addEventListener('pointercancel', hEnd);

    // Einrasten: nach dem Ziehen innerhalb ±0,6 cm der Flächenmitte (waagerecht) auf die Mitte
    var pd = null;
    function snapEnd(e) {
      var d = e.target.closest && e.target.closest('.splp-logo');
      if (!d || !pd || Math.abs(e.clientX - pd[0]) + Math.abs(e.clientY - pd[1]) < 3) return sched();
      var i = +d.dataset.i, lg = st.logos[i], o = lg && lg._splp;
      if (o && !rotated(d) && o.dx && Math.abs(o.dx) <= 0.6) apply(i, 0, o.dy || 0);
      sched();
    }
    box.addEventListener('pointerup', snapEnd);
    box.addEventListener('pointerdown', function (e) { pd = [e.clientX, e.clientY]; moved = true; sched(); });
    box.addEventListener('keydown', function (e) { if (e.isTrusted) { moved = true; sched(); } });

    new MutationObserver(seen).observe(layer, { attributes: true, subtree: true, childList: true, attributeFilter: ['style', 'class', 'hidden', 'x', 'y', 'width', 'height'] });
    new MutationObserver(sched).observe(stage, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(inject).observe(cards, { childList: true });
    el.addEventListener('spn:change', sched);

    // Warenkorb: Platzierungssatz als Property an die Hauptartikel (sp-pdp-neu.js übernimmt el.spnExtraProps)
    var orig = el.spnExtraProps;
    el.spnExtraProps = function () {
      var out = {};
      try { out = (typeof orig === 'function' ? orig.apply(this, arguments) : {}) || {}; } catch (e) {}
      try { st.logos.forEach(function (lg, i) { var s = sentence(i); if (s) out[tp(T.key, i + 1)] = s; }); } catch (e) { console.warn('[sp-logo-place]', e); }
      return out;
    };
    inject();
    return true;
  }

  function boot() {
    var n = 0;
    (function wait() {
      var roots = document.querySelectorAll('[data-spn-root]'), pending = !roots.length;
      Array.prototype.forEach.call(roots, function (el) { if (!init(el)) pending = true; });
      if (pending && n++ < 150) setTimeout(wait, 100);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();